import { CircularProgress } from "@material-ui/core";

export const RegisterButton = ({ loading, disable, action, text }) => {
  return (
    <button
      onClick={disable ? () => {} : action}
      type="submit"
      className={` bg-gradient-to-r from-primary to-blue-500 py-2.5
             text-base text-white rounded-xl w-full focus:outline-none hover:bg-primaryDark transition duration-500`}
    >
      {loading ? <CircularProgress size="20px" /> : text}
    </button>
  );
};

export const TableButton = ({ loading, action, text }) => {
  return (
    <div
      onClick={action}
      className={` py-1 bg-green-700 text-white    text-center text-sm cursor-pointer transition duration-500 px-2`}
    >
      {loading ? <CircularProgress size="20px" /> : `${text}`}
    </div>
  );
};

export const PendingTableButton = ({ loading, action, text }) => {
  return (
    <div
      onClick={action}
      className={` py-1 md:w-32  border  text-center text-sm cursor-pointer transition duration-500 px-2`}
    >
      {loading ? <CircularProgress size="20px" /> : `${text}`}
    </div>
  );
};

export const PrimaryButton = ({ text, loading, action, disabled }) => {
  return (
    <div
      onClick={disabled ? () => {} : action}
      className={`${
        disabled ? "bg-primary/50" : "bg-gradient-to-r from-primary to-blue-500"
      } cursor-pointer font-fontMedium text-center text-white py-4 w-full rounded-xl text-base mx-auto transition-all duration-500`}
    >
      {loading ? <CircularProgress size={20} /> : text}
    </div>
  );
};

export const SecondaryButton = ({ text, loading, action, disabled }) => {
  return (
    <div
      onClick={disabled ? () => {} : action}
      className={`${
        disabled ? "bg-[#D5F6EE]" : "bg-white"
      } cursor-pointer border border-[#CFCFCF] font-fontMedium text-center py-3 w-full rounded-md text-sm mx-auto transition-all duration-500`}
    >
      {loading ? <CircularProgress size={20} /> : text}
    </div>
  );
};
